module.exports = __webpack_public_path__ + "img/icon7.80451ed8.png";